import { createContext, ReactNode, useContext } from 'react';

export interface FeatureFlags {
  customer: string;
  oktaEnabled: boolean;
}

export interface FeatureFlagsContextProps {
  children: ReactNode;
}

export const FeatureFlagsContext = createContext<FeatureFlags | undefined>(undefined);

export const FeatureFlagsProvider = ({ children }: FeatureFlagsContextProps) => {
  const configs: FeatureFlags = {
    customer: window._env_.CUSTOMER,
    oktaEnabled: window._env_.OKTA_ENABLED === 'true' || window._env_.OKTA_ENABLED === true,
  };

  return <FeatureFlagsContext.Provider value={configs}>{children}</FeatureFlagsContext.Provider>;
};

// Custom hook to easily access the FeatureFlagsContext
export const useFeatureFlags = (): FeatureFlags => {
  const context = useContext(FeatureFlagsContext);
  if (context === undefined) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagsProvider');
  }
  return context;
};
